<form
    class="px-20 py-10"
    [formGroup]="form"
    #goalsForm>
    <button
        class="my-5"
        mat-flat-button
        color="primary"
        (click)="openAddGoalDialog()">
        Add new goal
    </button>
    <mat-tab-group
        preserveContent
        [selectedIndex]="activeTabIndex()"
        (selectedIndexChange)="activeTabIndex.set($event)">
        @for (tab of tabs(); track $index) {
            <mat-tab [label]="tab.value.label">
                <ng-template matTabContent>
                    <mat-accordion
                        multi
                        formArrayName="goals">
                        @for (
                            item of goalsArray.controls | appFilter: filterByGoalType(tab.key);
                            let goalIndex = $index;
                            track goalIndex
                        ) {
                            <mat-expansion-panel [formGroup]="item">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>{{ item.value.eventName }}</mat-panel-title>
                                    <mat-panel-description>
                                        $ {{ item.value.reward }}
                                    </mat-panel-description>
                                    <mat-panel-description>
                                        EXP {{ item.value.expReward }}
                                    </mat-panel-description>
                                    <mat-panel-description>
                                        {{ item.value.description }}
                                    </mat-panel-description>
                                </mat-expansion-panel-header>
                                <ng-template matExpansionPanelContent>
                                    <app-offer-goal [formGroup]="item"></app-offer-goal>
                                </ng-template>
                                <mat-action-row class="!justify-start">
                                    <button
                                        mat-flat-button
                                        color="warn"
                                        (click)="removeGoal(item)">
                                        Remove
                                    </button>
                                </mat-action-row>
                            </mat-expansion-panel>
                        }
                    </mat-accordion>
                </ng-template>
            </mat-tab>
        }
    </mat-tab-group>
    <button
        class="my-5 ml-4"
        mat-flat-button
        color="primary"
        id="scroll"
        (click)="updateGoals()">
        Save changes
    </button>
    <button
        class="my-5 ml-4"
        mat-flat-button
        color="primary"
        (click)="openAddGoalDialog()">
        Add new goal
    </button>
</form>
